import { colors } from '@globals/themes/defaultTheme'
import { mobileQuery } from '@globals/themes/themeConstants'
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutlined'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { T } from '@transifex/react'

const CheckIcon = styled(CheckCircleIcon)({
  fontSize: 48,
  color: colors.greenPrimary,
})

const cardStyle = {
  p: 3,
  alignItems: 'center',
  justifyContent: 'center',
  spacing: 1,
  mb: 4,
}

const titleStyle = {
  textAlign: 'center',
  mt: 0,
  [mobileQuery]: {
    mt: 0,
  },
}

const SetupComplete: React.FC = () => {
  return (
    <Card component={Stack} sx={cardStyle}>
      <CheckIcon />
      <Typography variant="h2" sx={titleStyle}>
        <T _str="Setup complete!" />
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center' }}>
        <T _str="Nice job launching your platform" />
      </Typography>
    </Card>
  )
}

export default SetupComplete
